<template>
    <v-card-text>
        <v-row dense class="mb-1" >
            <v-col cols="6" sm="4" class="mb-3">
                <span class="info-label">Total</span>
                <div class="info-value">R$ {{ booking.total_value }}</div>
            </v-col>
            <v-col v-if="booking.additional_value !== null" cols="6" sm="4" class="mb-3">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span class="info-label" v-bind="attrs" v-on="on">
                            Tarifa adicional <v-icon x-small>mdi-alert-octagram</v-icon>
                        </span>
                        <div class="info-value">{{ booking.additional_value }}</div>
                    </template>
                    <span>A Tarifa pode ser referente a:</span><br>
                    <span v-for="additional in additional_items" :key="additional.name"> - {{ additional.name }}<br></span>
                </v-tooltip>
            </v-col>
            <v-col v-if="booking.payment.payment_date !== null" cols="6" sm="4" class="mb-3">
                <span class="info-label">Data do pagamento</span>
                <div class="info-value">{{ paymentDate }}</div>
            </v-col>
            <v-col v-if="booking.hotel_confirmation_number" cols="6" sm="4" class="mb-3">
                <span class="info-label">HCN</span>
                <div class="info-value">{{ booking.hotel_confirmation_number }}</div>
            </v-col>
            <v-col cols="6" sm="4" class="mb-3">
                <span class="info-label">Método de pagamento</span>
                <div class="info-value">{{ paymentMethod }}</div>
            </v-col>
            <template v-if="canShowCard || showPixKey || booking.payment.payment_type === 'invoicing'">
                <v-col cols="12" v-if="canShowCard" class="payment-card__footer-actions">
                    <v-dialog v-model="cardDialog" max-width="410" class="rounded-xl bg-white">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" variant="tonal" @click="showVirtualCardModal()">
                                Ver cartão
                                <v-icon right>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>Cartão virtual</v-card-title>
                            <v-card-text class="pa-0 pb-4">
                                <payment-card
                                    :booking_id="booking.id"
                                    :payment_card_number="cardData.credit_card_number"
                                    :payment_cvv="cardData.cvv"
                                    :payment_expiration="cardData.expiration_date"
                                    :payment_amount="cardData.amount"
                                    :payment_status="cardData.card_status"
                                />
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-col>
                <v-col v-if="showPixKey" cols="6" sm="4">
                    <span class="info-label">Chave Pix</span>
                    <div class="info-value">{{ booking.payment.pix_key }}</div>
                </v-col>
                <v-col v-if="showPixKey" cols="6" sm="4">
                    <span class="info-label">Tipo da Chave</span>
                    <div class="info-value">{{ booking.payment.pix_key_type }}</div>
                </v-col>
                <v-col v-if="booking.payment.payment_type === 'invoicing'">
                    <span class="info-label">Observação</span>
                    <div class="info-value">O pagamento será feito por faturamento</div>
                </v-col>
                <v-col v-if="showPixKey" cols="12" class="payment-card__footer-actions">
                    <change-pix-key v-if="canChangePixKey" :booking="booking" />
                    <show-pix-receipt v-if="canShowPixReceipt" :booking="booking" />
                </v-col>
            </template>
        </v-row>

        <response-dialog :model="responseDialog" :type="responseType" :message="responseMessage" />
    </v-card-text>
</template>

<script>
import PaymentCard from "../PaymentCard.vue";
import ChangePixKey from "./Actions/ChangePixKey.vue";
import ShowPixReceipt from "./Actions/ShowPixReceipt.vue";
import ResponseDialog from "../../components/Dialog/ResponseDialog.vue";

export default {
    name: "BookingPayment",
    components: { ResponseDialog, ShowPixReceipt, ChangePixKey, PaymentCard },
    props: ['booking'],
    data: () => ({
        cardDialog: false,
        responseDialog: false,
        responseType: '',
        responseMessage: '',
        cardData: [],
        additional_items: [{ name: 'Água' }, { name: 'Café da Manhã' }, { name: 'Lavanderia' }],
    }),
    computed: {
        showPixKey() {
            return this.booking.payment.card_id === null && this.booking.payment.pix_key !== null;
        },
        canShowPixReceipt() {
            return this.booking.payment.payment_type === 'pix' && this.booking.payment.transaction_id !== null;
        },
        canChangePixKey() {
            return this.booking.payment.payment_type === 'pix' && this.booking.payment.transaction_id === null;
        },
        canShowCard() {
            return this.booking.payment.payment_type === 'virtualCard' && this.booking.payment.card_id !== null;
        },
        paymentMethod() {
            if (this.booking.payment.payment_type === 'virtualCard') return 'Cartão virtual';
            if (this.booking.payment.payment_type === 'pix') return 'Pix';
            if (this.booking.payment.payment_type === 'invoicing') return 'Faturamento';
        },
        paymentDate() {
            const dateParts = this.booking.payment.payment_date.split('-');
            return dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0];
        },
    },
    methods: {
        showVirtualCardModal() {
            axios.get('/api/card/show/' + this.booking.id, { headers: { ContentType: 'application/json' } })
                .then((res) => {
                    this.cardData = res.data.card;
                    this.cardDialog = !this.cardDialog;
                })
                .catch(() => {
                    this.responseDialog = true;
                    this.responseType = 'error';
                    this.responseMessage = 'Erro ao buscar dados do cartão virtual!';
                });
        },
    },
}
</script>

<style scoped>
.info-label {
    display: block;
    font-size: 11px;
    font-weight: 500;
    color: #757575;
    text-transform: uppercase;
    letter-spacing: 0.4px;
}

.info-value {
    margin-top: 3px;
    font-size: 15px;
    font-weight: 600;
    color: #434347;
}

.payment-card__footer-actions {
    margin-top: 1.25rem;
    padding-top: 1rem;
    padding-bottom: 0;
    border-top: 1px solid rgba(0, 0, 0, .12);
}
</style>
